import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { CatalogForm } from "../CatalogForm";
import { CreateCatalogModalProps } from "./types";
import { useCreateCatalogModal } from "./controller";

export const CreateCatalogModal = React.memo(
  ({ modalRef, onComplete }: CreateCatalogModalProps) => {
    const translate = useTranslate();

    const { methods, mutateAsync, isPending } = useCreateCatalogModal(modalRef, onComplete);

    return (
      <Modal
        ref={modalRef}
        title={translate("catalog.titles.create")}
        onConfirm={mutateAsync}
        methods={methods}
        isPending={isPending}
      >
        <CatalogForm />
      </Modal>
    );
  }
);
